import { useLocationStore } from '@shared/global-store/stores/location/location'
import type { TypedDocumentString } from '@shared/types/storefront/graphql'

import { isHttpError } from '@fond-of/api-client'

export const execute = async <TResult, TVariables>(
  query: TypedDocumentString<TResult, TVariables>,
  ...[variables]: TVariables extends Record<string, never> ? [] : [TVariables]
): Promise<TResult | null> => {
  const locationStore = useLocationStore()

  const url = `${import.meta.env.PUBLIC_SHOPIFY_STORE_API_URL}/api/2025-07/graphql.json`

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': import.meta.env
          .PUBLIC_SHOPIFY_STORE_API_TOKEN,
      },
      body: JSON.stringify({
        query,
        variables: {
          ...variables,
          country: locationStore.country,
          language: locationStore.language,
        },
      }),
    })

    const resp = await response.json()

    if (resp.errors) {
      console.log('GraphQL errors', resp.errors)
    }

    return resp.data as TResult
  } catch (error) {
    console.error(
      'Failed to fetch Shopify data',
      isHttpError(error) ? await error.response.json() : error
    )
    return null
  }
}
